export function setGrupos(state, grupos) {
    state.grupos = grupos;
}

export function setGrupoSelec(state, grupo) {
    state.grupoSelec = grupo;
}

export function setOrdenGrupo(state, ordenGrupo) {
    state.ordenGrupo = ordenGrupo;
}



export function actListGrupos(state, grupo) {
    if (grupo !== null) {
        const index = state.grupos.findIndex(r => r.id === grupo.id)
        if (index != -1) {
            state.grupos[index].nombre = grupo.nombre;  
            state.grupos[index].descripcion = grupo.descripcion;  
            state.grupos[index].responsable = grupo.responsable;  
            state.grupos[index].telefono = grupo.telefono;  
            state.grupos[index].email = grupo.email;  
            state.grupos[index].grupo_id = grupo.grupo_id;  
        }
    }
}

export function actDeleteListGrupos(state, id) {
    if (id != null) {
        const index = state.grupos.findIndex(r => r.id === id)
        if (index != -1) {
            state.grupos.splice(index, 1)
        }
    }
}



export function actListOrigenesFromGrupos(state, origen) {
    if (origen !== null) {
        for (let i = 0; i < state.grupos.length; i++) {
            const index = state.grupos[i].origenes.findIndex(r => r.id === origen.id)
            if (index != -1) {
                state.grupos[i].origenes[index].nombre = origen.nombre;
                state.grupos[i].origenes[index].descripcion = origen.descripcion;
                state.grupos[i].origenes[index].telefono = origen.telefono;
                state.grupos[i].origenes[index].email = origen.email;
                state.grupos[i].origenes[index].responsable = origen.responsable;
                state.grupos[i].origenes[index].grupo_id = origen.punto_id;
            } 
        }
    }
}

export function actDeleteListOrigenesFromGrupos(state, id) {
    if (id != null) {
        for (let i = 0; i < state.grupos.length; i++) {
            const index = state.grupos[i].origenes.findIndex(r => r.id === id)
            if (index != -1) {
                state.grupos[i].origenes.splice(index, 1)
            }
        }
    }
}



